import { Accordion, Join } from 'react-daisyui';
import { useTranslation } from 'react-i18next';
import { useChatContext } from '../../Chat.hook.ts';
import ChatInfoAttributes from './components/ChatInfoAttributes/ChatInfoAttributes.component.tsx';
import ChatInfoNotes from './components/ChatInfoNotes/ChatInfoNotes.component.tsx';
import ChatInfoLeadsalesAI from './components/ChatInfoLeadsalesAI/ChatInfoLeadsalesAI.component.tsx';
import ChatInfoProgrammedMessages from './components/ChatInfoProgrammedMessages/ChatInfoProgrammedMessages.component.tsx';
import ChatInfoStaredMessages from './components/ChatInfoStaredMessages/ChatInfoStaredMessages.component.tsx';
import { CHAT_INFO_ATTRIBUTES_TOGGLE_ID } from './ChatInfo.functions.ts';
import './ChatInfo.styles.scss';

export default function ChatInfo() {
  const { selectedChat } = useChatContext();
  const { t } = useTranslation(['chat/chat']);

  return (
    <Join className="ChatInfo" vertical={true} key={selectedChat?.id}>
      <Accordion
        icon="arrow"
        defaultChecked
        className="ChatInfo__Accordion"
        id={CHAT_INFO_ATTRIBUTES_TOGGLE_ID}
      >
        <Accordion.Title className="ChatInfo__Accordion__Title">
          {t('chatInfo.attributes')}
        </Accordion.Title>
        <Accordion.Content className="px-0">
          <ChatInfoAttributes />
        </Accordion.Content>
      </Accordion>
      <Accordion icon="arrow" className="ChatInfo__Accordion">
        <Accordion.Title className="ChatInfo__Accordion__Title">
          {t('chatInfo.notes')}
        </Accordion.Title>
        <Accordion.Content className="px-0">
          <ChatInfoNotes />
        </Accordion.Content>
      </Accordion>
      <Accordion icon="arrow" className="ChatInfo__Accordion">
        <Accordion.Title className="ChatInfo__Accordion__Title">
          {t('chatInfo.leadsalesAI')}
        </Accordion.Title>
        <Accordion.Content className="!pb-[1px] px-0">
          <ChatInfoLeadsalesAI />
        </Accordion.Content>
      </Accordion>
      <Accordion icon="arrow" className="ChatInfo__Accordion">
        <Accordion.Title className="ChatInfo__Accordion__Title">
          {t('chatInfo.programmedMessages')}
        </Accordion.Title>
        <Accordion.Content className="px-0">
          <ChatInfoProgrammedMessages />
        </Accordion.Content>
      </Accordion>
      <Accordion icon="arrow" className="ChatInfo__Accordion">
        <Accordion.Title className="ChatInfo__Accordion__Title">
          {t('chatInfo.staredMessages')}
        </Accordion.Title>
        <Accordion.Content className="px-0">
          <ChatInfoStaredMessages />
        </Accordion.Content>
      </Accordion>
    </Join>
  );
}
